<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft">
    <div :class="$style.dropdown">
      <a-avatar
        shape="square"
        icon="user"
        size="large"
        :class="$style.avatar"
      />
    </div>
    <a-menu slot="overlay" vi-if="auth && auth.userId">
      <a-menu-item>
        <div>
          <strong>
            {{ $t("topBar.profileMenu.hello") }},
            {{ auth.fullname || auth.username }}</strong
          >
        </div>
        <div v-if="auth.position && auth.position.name">
          <strong class="mr-1">
            Chức vụ:
          </strong>
          {{ auth.position.name }}
        </div>
        <div v-if="auth.department && auth.department.name">
          <strong class="mr-1">
            Phòng ban:
          </strong>
          {{ auth.department.name }}
        </div>
        <!-- <div>
          <strong class="mr-1">
            {{ $t("topBar.profileMenu.billingPlan") }} :
          </strong>
          Professional
        </div>
        <div>
          <strong class="mr-1">{{ $t("topBar.profileMenu.role") }}:</strong>
          {{ auth.role }}
        </div> -->
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <div>
          <strong class="mr-1">{{ $t("topBar.profileMenu.email") }}:</strong>
          {{ auth.email }}
        </div>
        <div>
          <strong class="mr-1">{{ $t("topBar.profileMenu.phone") }}:</strong> -
        </div>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <a href="javascript: void(0);">
          <i class="fe fe-user mr-2"></i>
          {{ $t("topBar.profileMenu.editProfile") }}
        </a>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <a href="javascript: void(0);" @click="logout">
          <i class="fe fe-log-out mr-2"></i>
          {{ $t("topBar.profileMenu.logout") }}
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions({
      logoutAction: "auth/logout",
    }),
    logout() {
      this.logoutAction();
      // this.$router.push("/auth/login");
    },
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
